import type { TFunction } from 'i18next'
import { z } from 'zod'

/**
 * Form-shape schema for the binding section.
 *
 * `meterRef` is hidden from the UI (LC-168 staging onboarding confirmed it's optional and not
 * needed for the local-control flow). It still round-trips on disk — save merges the form-supplied
 * `batteryRef` into the existing `binding` object so any pre-existing `meterRef` survives.
 */
export function getBindingFormSchema(t: TFunction) {
  return z.object({
    batteryRef: z
      .string()
      .trim()
      .min(1, { message: t('resources.local_control.binding.battery_ref_required') }),
  })
}

export type BindingFormSchemaType = z.infer<ReturnType<typeof getBindingFormSchema>>
